import { experienceBuilderApi } from 'api'

export interface UploadResourcePayload {
  title: string
  link: string
  description: string
  skills: string
  resourceType: boolean
  geography: string
  jobFamily: string
}

export interface UploadResourceRes {
  success: boolean
}

export const submitUploadResource = (payload: UploadResourcePayload) => {
  return experienceBuilderApi.post<UploadResourceRes>('/marketing-capabilities/addResource', payload)
}
